// en.home.ts
const home = {
  nav: {
    home: "Home",
    about: "About",
    mission: "Mission",
    moments: "Moments",
    advertise: 'Advertise',
    login: "Log in",
    createAccount: "Create account",
  },  

  hero: {
    title: "What’s happening around you.",
    subtitle: "Your vibe, your city.",
    description:
      "Elnydo is a social media app where you can share videos and pictures and see what other people around you are doing. No comments. Only likes and real moments.",
    ctaCreateAccount: "Create account",
    ctaLogin: "Log in",
    quote:
      "“Catch the vibe near you.” – see the party, the streets, the cafés and everyday life around you in real time.",
  },

  about: {
    overlayTitle: "Live from your city",
    overlaySubtitle: "Real moments, right now.",
    title: "About us",
    p1:
      "Elnydo is a social media app where you can post pictures and videos and explore what other people are sharing around you.",
    p2:
      "Your feed is always sorted by distance – first your city, then your country, then nearby countries. You don’t have to search or follow a hundred accounts to see what’s going on: Elnydo shows you what’s happening around you right now.",
    p3:
      "No comments, no drama, no endless arguments. Just real moments, likes, and a simple way to feel the vibe of your city and discover new places through the eyes of the people who live there.",
  },

  mission: {
    title: "Our mission",
    missionLead: "Our mission is simple:",
    missionStatement:
      "To connect people by showing what is happening around you.",
    p1:
      "Elnydo lets you see the world through real people, not curated ads or endless comment threads. Your feed moves from your city, to your country, to nearby countries – like zooming out on a live, interactive map of moments.",
    p2:
      "Every video and picture is a tiny window into what’s happening right now: parties, streets, cafés, concerts, everyday life. You don’t just scroll a feed – you explore a living world.",
    overlayTitle:
      "A world of moments.... show a world to showcase the interconnection",
    overlaySubtitle: "From your street to the next country – all in one view.",
  },

  moments: {
    title: "Moments from the world",
    description:
      "Here you can showcase example clips from your app – You need to make them as a link so first impression of the App can be seen live Posts from these chosen cities...",
    cards: {
      paris: {
        title: "Paris • Eiffel Tower",
        description: "Night lights, street music and friends hanging out.",
      },
      london: {
        title: "London • Big Ben",
        description: "Rainy evening, city lights and late-night walks.",
      },
      vienna: {
        title: "Vienna • Schönbrunn",
        description: "Golden hour in the city, calm and beautiful.",
      },
    },
  },

   ads: {
    title: 'Advertising on Elnydo',
    description:
      'Tell your story through immersive, cinematic advertising designed to feel native — not intrusive.',
    subtext:
      'Reach real people in moments that matter. Privacy-first, brand-safe, and built for modern storytelling.',
    cta: 'Advertise on Elnydo',
  },

  cta: {
    title: "Ready to see what’s happening around you?",
    description:
      "Create a free account, post your first moments and explore your city one video at a time.",
    createAccount: "Create account",
    login: "Log in",
  },

  footer: {
    tagline: "What’s happening around you.",
    links: {
      termsOfUse: "Terms of Use",
      privacyPolicy: "Privacy Policy",
      helpSupport: "Help & Support",
    },
    
    language: "Language",
  },
};

export default home;
